import api from '@shared/services/api';
import { CreateGroupPayload, UpdateGroupPayload } from '../types';

export const GroupService = {
  /**
   * Create a new group conversation via backend API
   */
  async createGroup(data: CreateGroupPayload): Promise<string> {
    const response = await api.post<{ groupId: string }>('/groups', data);
    return response.data.groupId;
  },

  /**
   * Update an existing group conversation via backend API
   */
  async updateGroup(groupId: string, data: UpdateGroupPayload): Promise<void> {
    await api.patch(`/groups/${groupId}`, data);
  },
};
